import React from 'react';
import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import { CarouselTabs } from '../../CarouselTabs/CarouselTabs';
import { ChipTab } from '../../CarouselTabs/ChipTab/ChipTab';
import { InfoModuleProps } from '../InfoModule/InfoModule';
import { BundleModuleProps } from '../BundleModule';
import {
  EnhancedProductCarousel,
  EnhancedProductCarouselProps,
} from '../EnhancedProductCarousel/EnhancedProductCarousel';
import { PossiblyResponsiveValue } from '../../hooks/useResponsiveValue';
import { ProductCardVariant } from '../../ProductCard/ProductCard';
import { toKebabCase } from '@jbhi-fi/utils/src/toKebabCase';

export interface SlideoutProductsModuleProps {
  groupedSuggestions?: Array<{
    heading: string;
    infoModuleProps?: InfoModuleProps;
    bundleModuleProps?: BundleModuleProps;
    products: Array<AlgoliaProductHit>;
  }>;
  suggestions?: Array<AlgoliaProductHit>;
  numProductsPerCategory?: number;
  numProductsPerNonBundleCategory?: number;
  cardVariant?: PossiblyResponsiveValue<ProductCardVariant>;
  trackingData?: EnhancedProductCarouselProps['trackingData'];
}

export const SlideoutProductsModule = ({
  groupedSuggestions,
  suggestions,
  numProductsPerCategory,
  numProductsPerNonBundleCategory,
  cardVariant,
  trackingData,
}: SlideoutProductsModuleProps) => {
  return (
    <div>
      {groupedSuggestions?.length ? (
        <CarouselTabs
          borderBottomColor="transparent"
          label="Add: "
          tabs={groupedSuggestions.map((suggestion, i) => ({
            renderLabel: tabProps => <ChipTab label={suggestion.heading} {...tabProps} />,
            contents: (
              <EnhancedProductCarousel
                key={i}
                products={suggestion.products}
                infoModuleProps={suggestion.infoModuleProps}
                bundleModuleProps={suggestion.bundleModuleProps}
                numProducts={numProductsPerCategory}
                cardVariant={cardVariant}
                trackingData={trackingData}
                testId="slideout-product-suggestions"
              />
            ),
            labelTestId: `slideout-product-suggestions-tab-${toKebabCase(suggestion.heading)}`,
          }))}
        />
      ) : suggestions?.length ? (
        <EnhancedProductCarousel
          products={suggestions}
          numProducts={numProductsPerNonBundleCategory}
          cardVariant={cardVariant}
          trackingData={trackingData}
          testId="slideout-product-suggestions"
        />
      ) : null}
    </div>
  );
};
